var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-more",on:{"click":_vm.click}},[_c('div',{staticClass:"button-more-text",class:_vm.disabled ? 'button-more-disabled' : ''},[_vm._v(_vm._s(_vm.isFull ? _vm.closeText : _vm.moreText))]),_vm._v(" "),_c('div',{staticClass:"button-more-arrow",class:_vm.disabled ? 'button-more-disabled' : ''})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7012fdba","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/MoreButton.vue
// module id = null
// module chunks = 